import React from 'react'

const SvgF5 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M3 6.01h4v11.992H3V6.01zM13 5.998h4v6.994h-4V5.998zM7 6.01h4.086v1.992H7V6.01z' />
    <path d='M6.957 11h4.086v1.992H6.957V11zM17 5.998h4V7.99h-4V5.998z' />
    <path d='M17 5.998h4V7.99h-4V5.998zM13 16.002h6v1.992h-6v-1.992zM17 11h4v1.992h-4V11z' />
    <path d='M21 12.006v5.996h-2.917v-5.996H21z' />
  </svg>
)

export default SvgF5
